module.exports = "/_next/static/images/DeepenUnderstanding@2x-11b556ab1c3f20929b7708ec5ba4e3a1.webp";